import { useFragment } from '@apollo/client/react';

import { checkIsTemplate } from '@trello/business-logic/board';

import { IsTemplateBoardFragmentDoc } from './IsTemplateBoardFragment.generated';

export const useIsTemplateBoard = (boardId: string): boolean => {
  const { data: fragmentData, complete } = useFragment({
    fragment: IsTemplateBoardFragmentDoc,
    fragmentName: 'IsTemplateBoard',
    from: {
      id: boardId,
      __typename: 'Board',
    },
  });

  // The codegen fragment hook returned `undefined` until the read was
  // complete; this gate preserves that and may be removable later.
  const data = complete ? fragmentData : undefined;

  const { prefs, premiumFeatures } = data || {};
  return checkIsTemplate({
    isTemplate: prefs?.isTemplate,
    permissionLevel: prefs?.permissionLevel,
    premiumFeatures,
  });
};
